/*jshint esversion: 6 */
jQuery(window).on('load', function () {
    (function () {
        if(location.pathname.indexOf('/comps') != -1 ){
            ApproachCalculator.check_unit_val =   ApproachCalculator.calculateUnits();
            $('.required_class').removeClass('required');
        }else{
            $('.required_class').addClass('required');
        }

        $("#sale_comps").prop('checked', 'checked');
        stopLoading('body');
        $("#start_date").val("");
        $("#end_date").val("");
        $("label[for='start_date']").removeClass("active");
        $("label[for='end_date']").removeClass("active");
        
        $("select").change(function () {
            $(this).next('.error').remove();
        });

        // var loadSideNav = function () {
        //     var buttonSettings = {
        //         menuWidth: '50%',
        //         edge: 'left',
        //         closeOnClick: false,
        //         onClose: function (el) {
        //             resetForm();
        //         }
        //     };

        //     $('.button-collapse').sideNav(buttonSettings);

        //     var datePickerConfigs = {
        //         range: true,
        //         closeOnSelect: true,
        //         closeOnClear: true,
        //         selectMonths: true, // Creates a dropdown to control month
        //         selectYears: 15, // Creates a dropdown of 15 years to control year,
        //         today: 'Today',
        //         clear: 'Clear',
        //         close: 'Ok',
        //         format: 'mm/dd/yyyy',
        //         container: $('#slide-out').find('.container'),
        //         onRender: function () {
        //             // $('.picker__date-display').remove();
        //         },
        //         onClose: function () {
        //             $(document.activeElement).blur();
        //         }
        //     };

        //     $('#slide-out').find('.comps-datepicker').pickadate(datePickerConfigs);
        //     initImageCropper();

        //     var utilSelect = $("#utilities_select");
        //     var utilInput = $('#utilities_other').parent('.input-field');

        //     // Allow 'Other' selection of Utilities
        //     var checkUtils = function (e) {
        //         if (e.val() === 'other') {
        //             utilInput.removeClass('hide');
        //         } else if (!utilInput.hasClass('hide')) {
        //             utilInput.addClass('hide');
        //         }
        //     };
        //     utilSelect.on('change', function () {
        //         checkUtils($(this));
        //     });
        // };

        var initImageCropper = function () {
            $('input[name=property_image_url]').change(function () {
                var input = this;
                var url = $(this).val();
                var ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();

                if (input.files && input.files[0] && (ext == "gif" || ext == "png" || ext == "jpeg" || ext == "jpg")) {
                    var reader = new FileReader();

                    reader.onload = function (e) {
                        $('#comps-form').find('#image').attr('src', e.target.result);
                        $('#comps-form').find('#image').cropper({
                            aspectRatio: 16 / 9
                        });

                        $('#comps-form').find('.comps-image-container > .file-field').hide();
                    };

                    reader.readAsDataURL(input.files[0]);
                }
            });
        };
        var saveCompExcel = function(e){
            e.preventDefault();
            var form = $("#compsExcelImport");
            var data = new FormData(form[0]);
            if (form.valid()) {
                $.ajax({
                    type: "POST",
                    url: $("body").data("base-url") + "comps/saveCompsExcel",
                    data: data,
                    cache: false,
                    contentType: false,
                    processData: false,
                    beforeSend: function (xhr) {
                        $('body').LoadingOverlay("show",
                            {
                                image: $('body').attr('data-base-url') + "assets/img/loading.png",
                                imageAnimation: '2500ms rotate_left',
                                zIndex: 1020,
                                background: "rgba(255, 255, 255, 0.95)"
                            }
                        );
                    },
                    success: function (responseText) {
                        var data = JSON.parse(responseText);
                        if(data.status=="fail" || data.status=="success"){
                            Materialize.toast(data.msg,2000);
                        }
                        else if(data.status=="partially_added"){
                            Materialize.toast(data.msg,1000);
                            $('body').LoadingOverlay("hide");
                            $("#partially_added_comps_modal").modal('open',{backdrop: 'static', keyboard: false});
                            var dataTable = $('#partial-comps-modal-table').DataTable();
                            dataTable.destroy();

                            $("#partial-comps-modal-table").html(data.comps);
                            $('#partial-comps-modal-table').DataTable(
                                { 
                                    "searching": false,
                                    "lengthChange": false,
                                    "pagination": false,
                                    "paginate": false, 
                                }
                            );
                        }
                        $('.upload_comps_close').click();
                        return false;
                    },
                    failure: function (errMsg) {
                        Materialize.toast("It was not possible to execute that action.", 2000);
                    }
                }).done(function () {
                    $('body').LoadingOverlay("hide");
                    $('.table_wrap').removeClass('hide');
                    $('#advance-listings-map').addClass('hide');
                    TableController.Comps.refresh();
                    TableController.Lease.refresh();
                });
            }
        };
        var openAdvanceFilter = function(e){
            e.preventDefault();
            $('#select-comp').modal('open');
            setModalFields();
        };
        
        var clearFilters = function () {
            $('#results_format').prop('checked', false);
            var property_type = $('select[name="property_type"]');
            property_type.val("");
            property_type.material_select();
            var property_sub_type = $('select[name="property_sub_type"]');
            property_sub_type.val("");
            property_sub_type.material_select();
            var state = $('select[name="state"]');
            state.val("");
            state.material_select();
            change_state(state);
            var lease_type = $('select[name="lease_type"]');
            lease_type.val("");
            lease_type.material_select();
            var select_comp_type_modal = $('select[name="select_comp_type_modal"]');
            select_comp_type_modal.val("building_with_land");
            select_comp_type_modal.material_select();
            select_comp_type_modal.change();
            $("label[for='city']").removeClass("active");
            $('[name="filter_street_address"]').val("");
            $('[name="filter_street_address"]').parent().find('label').removeClass('active');
            $('[name="start_date"]').val("");
            $('[name="start_date"]').parent().find('label').removeClass('active');
            $('[name="end_date"]').val("");
            $('[name="end_date"]').parent().find('label').removeClass('active');
            $('[name="square_footage_min"]').val("");
            $('[name="square_footage_min"]').parent().find('label').removeClass('active');
            $('[name="square_footage_max"]').val("");
            $('[name="square_footage_max"]').parent().find('label').removeClass('active');
            $('[name="land_sf_min"]').val("");
            $('[name="land_sf_min"]').parent().find('label').removeClass('active');
            $('[name="land_sf_max"]').val("");
            $('[name="land_sf_max"]').parent().find('label').removeClass('active');
            $('[name="cap_rate_min"]').val("");
            $('[name="cap_rate_min"]').parent().find('label').removeClass('active');
            $('[name="cap_rate_max"]').val("");
            $('[name="cap_rate_max"]').parent().find('label').removeClass('active');
            $('[name="price_sf_min"]').val("");
            $('[name="price_sf_min"]').parent().find('label').removeClass('active');
            $('[name="price_sf_max"]').val("");
            $('[name="price_sf_max"]').parent().find('label').removeClass('active');
        };
        var setModalFields = function(e){
            clearFilters();
            if($(".select_lease_sale:checked").val()=='lease_comps'){
                $("#comp_type_text").val("Lease");
                $("select[name='comp_type']").val("lease");
                $("select[name='comp_type']").material_select();
                replaceFieldsLabel('lease');
                $('.hide_if_sale_comps').removeClass('hide');
                $('.hide_if_lease_comps').addClass('hide');
            }else{
                $("#comp_type_text").val("Sale");
                $("select[name='comp_type']").val("sale");
                $("select[name='comp_type']").material_select();
                replaceFieldsLabel('sale');
                $('.hide_if_lease_comps').removeClass('hide');
                $('.hide_if_sale_comps').addClass('hide');
            }
        };

        $("select[name='city[]']").change(_.debounce(function () {
            $(this).material_select();
        }, 1800));
        
        var update_filter_label = function(text,icon){
            $('#open_advance_filter_modal').attr('data-tooltip',text);
            $('.filter_icon').text(icon);
        };

        $(document).on('click', '#clear_filter', function () {
            $('#check_advance_filter').val(0);
            $('#clear_filter').addClass('hide');
            update_filter_label('Apply Advance Filter','filter_alt');
            refresh_filters();
        });

        if (location.pathname.indexOf('/comps') !== -1) {
            $(document).on('click', '.get_comps_for_table', function () {
                $('#check_advance_filter').val(1);
                $('#clear_filter').removeClass('hide');
                update_filter_label('Advance Filter Applied','filter_list');
                refresh_filters();
                if($('#results_format').is(':checked')){
                    $('.table_wrap').addClass('hide');
                    $('#advance-listings-map').removeClass('hide');
                    loadListings();
                }else{
                    $('.table_wrap').removeClass('hide');
                    $('#advance-listings-map').addClass('hide');
                    $("#response_div_map").addClass("hide");
                }
            });
        }

        var loadListings = function () {
            EvaluationsCommons.initMap();
            EvaluationsCommons.clean();
            var formValues= $("#form_modal").serialize();   
            $.ajax({
                type: "POST",
                url: $("body").data("base-url") + "comps/get_comps",
                data: formValues,
                success: function (responseText) {
                    EvaluationsCommons.resetMarkers();
                    $("#comps-modal-table").html();
                    var comp = JSON.parse(responseText);
                    if(comp.data.length){
                        $(comp.data).each(function (index, instance) {
                            EvaluationsCommons.buildListing(instance);
                        });
                        $("#advance-listings-map").removeClass("hide");
                        $("#response_div_map").addClass("hide");
                    }else{
                        $("#advance-listings-map").addClass("hide");
                        $("#response_div_map").removeClass("hide");
                    }
                    EvaluationsCommons.fitBounds();
                    EvaluationsCommons.checkMap();
                },
            });
        };
        if ($('input.table-search_field').length > 0) {
            $('input.table-search_field').keyup(function () {
                $("#response_div_map").addClass("hide");
                $('.table_wrap').removeClass('hide');
                $('#advance-listings-map').addClass('hide');
            });
        }

        var refresh_filters = function(){
            $("#response_div_map").addClass("hide");
            $('.table-search_field').val('');
            if ($.fn.DataTable.isDataTable('#comps-table')) {
                $('#comps-table').DataTable().destroy();
            }
            $('#comps-table tbody').empty();
            TableController.Comps.init();
            if ($.fn.DataTable.isDataTable('#lease-table')) {
                $('#lease-table').DataTable().destroy();
            }
            $('#lease-table tbody').empty();
            TableController.Lease.init();
            $('#select-comp').modal('close');
        };

        var replaceFieldsLabel = function(type){
            var date = 'Lease';
            var date_replace = 'Sale';
            var building = 'Space';
            var building_replace = 'Building';
            if(type=='lease'){
                date = 'Sale';
                date_replace = 'Lease';
                building = 'Building';
                building_replace = 'Space';
            }
            $("label[for='start_date']").html($("label[for='start_date']").html().replace(date,date_replace));
            $("label[for='end_date']").html($("label[for='end_date']").html().replace(date,date_replace));
            $("label[for='square_footage_min']").html($("label[for='square_footage_min']").html().replace(building,building_replace));
            $("label[for='square_footage_max']").html($("label[for='square_footage_max']").html().replace(building,building_replace));
        };

        var saveComp = function () {
            $('#save-comp').attr('disabled',true);
            showLoading();
            Utils.setIndexes('zonings', 7);
            Utils.setIndexes('property_unit', 6); 
            if ($("select[name='type']").val() === 'sale') {
                $("select[name='lease_type']").val('');
                $("[name=lease_rate]").val('');
                $("[name=term]").val('');
            } else if ($("select[name='type']").val() === 'lease') {
                $("[name=sale_price]").val('');
                $("[name=net_operating_income]").val('');
                $("[name=cap_rate]").val('');
            }
            var form = $("#comps-form");
            if (form.valid()) {
                unmaskFields();
                
                $('.space').each(function() { 
                    $(this).val($(this).val().replace(/\$|\s|[, ]/g, ''));
                });
                
                var data = new FormData(form[0]);
                if (form.find('#image').data('cropper') !== undefined) {
                    form.find('#image').cropper('getCroppedCanvas').toBlob(function (blob) {
                        var fileInput = form.find("input[name=property_image_url][type=file]");
                        var filename = '';

                        if(fileInput.hasOwnProperty(0)) {
                            fileInput = fileInput[0];
                            if(fileInput.files) {
                                fileInput = fileInput.files;
                                if(fileInput.hasOwnProperty(0)) {
                                    fileInput = fileInput[0];
                                    if(fileInput.name) {
                                        filename = fileInput.name;
                                    }
                                }
                            }
                        }

                        if(filename.length === 0) {
                            filename = 'property_image_url';
                        }

                        data.append('property_image_url', blob, filename);
                        send(data);
                    },"image/jpeg",0.75);
                } else {
                        send(data);
                }
            } else {
                Utils.unsetIndexes('zonings', 7);
                Utils.unsetIndexes('property_unit', 6);
                Materialize.toast('Please complete the missing fields.', 3000, 'blue');
                $('#save-comp').attr('disabled',false);
                hideLoading();
            }
        };

        var send = function (data) {
            $.ajax({
                type: "POST",
                url: $("body").data("base-url") + "comps/save",
                data: data,
                cache: false,
                contentType: false,
                processData: false,
                beforeSend: function (xhr) {
                    showLoading();
                },
                success: function (responseText) {
                    var comp = JSON.parse(responseText);

                    if(comp.status=="fail"){
                        Materialize.toast(comp.message,3000);
                        return false;
                    }else if (comp.id) {
                        if (comp.update) {
                            Materialize.toast("Comp has been updated.", 2000);
                        } else {
                            Materialize.toast("Comp has been created.", 2000);
                        }
                        window.location.href = $("body").data("base-url") + "comps";
                    }
                },
                failure: function (errMsg) {
                    Materialize.toast("It was not possible to execute that action.", 2000);
                    $('#save-comp').attr('disabled',false);
                    stopLoading('body');
                }
            }).done(function () {
                hideLoading();
            });
        };

        var showLoading = function () {
            $('body').LoadingOverlay("show",
                {
                    image: $('body').attr('data-base-url') + "assets/img/loading.png",
                    imageAnimation: '2500ms rotate_left',
                    zIndex: 1005,
                    background: "rgba(255, 255, 255, 0.95)"
                }
            );
        };

        var hideLoading = function () {
            $('body').LoadingOverlay("hide");
        };

        var unmaskFields = function () {
            $('.currency').each(function (index, value) {
                $(this).val($(this).maskMoney('unmasked')[0]);
            });

            $('.area').each(function (index, input) {
                $(this).val(Utils.unmaskArea($(input).val()));
            });

            $('.percentage').each(function (index, input) {
                $(this).val($(this).maskMoney('unmasked')[0]);
            }); 
            
            $('.postmask-integer, .postmask-currency, .postmask-percentage, .postmask-money').each(function (index, value) {
                $(this).val($(this).val().replace(/[^\d.-]/g, ''));
            });
        };
        /* now the delete comps function is in table.js file */
        
        // var doDeleteComp = function () {
        //     $.ajax({
        //         type: "POST",
        //         url: $("body").data("base-url") + "comps/delete",
        //         data: $("#comps-form").serialize(),
        //         beforeSend: function (xhr) {
        //             showLoading();
        //         },
        //         success: function (responseText) {
        //             var comp = JSON.parse(responseText);
        //             if(comp == "existInEval")
        //             {
        //                 Materialize.toast("This comp is currently used in an Evaluation and cannot be deleted.", 2000);
        //             }else if (comp.id) {
        //                 TableController.Comps.refresh();
        //                 TableController.Lease.refresh();
        //                 $('.table_wrap').removeClass('hide');
        //                 $('#advance-listings-map').addClass('hide');
        //                 Materialize.toast("Comparative has been removed.", 2000);
        //                 if (location.pathname.indexOf('/master-properties') !== -1) {
        //                     reload_comp_data();
        //                 }
        //             }
        //             loadSideNav();
        //         },
        //         failure: function (errMsg) {
        //             Materialize.toast("It was not possible to remove comparative right now.", 2000);
        //         }
        //     }).done(function () {
        //         hideLoading();
        //         closeForm();
        //     });
        //     // closeForm();
        // };

        var deleteComp = function () {
            deleteConfirm(doDeleteComp);
        };

        var closeForm = function () {
            $('.button-collapse').sideNav('hide');
            $('#comps-form').find('input[type="text"]').blur();
            $(".comps-image").fadeTo("fast", 1);
            $("#comps-form").validate().resetForm();
            $('#image').cropper('destroy');
        };

        var closeDetails = function () {
            $('.drawer').removeClass('open');
            window.scrollTo(0, 0);
            history.pushState("", document.title, window.location.pathname + window.location.search);
        };

        var showDetails = function(el) {
            $('.details').scrollTop(0);
            var id = $(el).attr('data-id');

            $.ajax({
                url: $("body").data("base-url") + 'comps/getDetails',
                data: {id: id},
                beforeSend: function () {
                    $('.drawer').addClass('open');
                    $("body").LoadingOverlay("show",
                        {
                            image: $('body').attr('data-base-url') + "assets/img/loading.png",
                            imageAnimation: '2500ms rotate_left',
                            zIndex: 1002,
                            background: "rgba(255, 255, 255, 0.95)"
                        }
                    );
                },
                success: function (responseText) {
                    window.scrollTo(0, 0);
                    var data = JSON.parse(responseText);
                    fillDetails(data);
                }
            }).done(function (data) {
                initCarousel();
                $('body').LoadingOverlay("hide");
                window.scrollTo(0, 0);
            });
        };

        var fillDetails = function (data) {
            try {
                var compDetail = $('#property-detail');
                var body = $('body');

                /*Property section*/
                var comp = data.comps;
                if (comp.type=="sale") {
                    compDetail.find('.sale_dt').removeClass("hide");
                    compDetail.find('.hide-if-lease').removeClass("hide");
                    compDetail.find('.hide-if-sale').addClass("hide");
                } else {
                    compDetail.find('.sale_dt').addClass("hide");
                    compDetail.find('.hide-if-lease').addClass("hide");
                    compDetail.find('.hide-if-sale').removeClass("hide");
                }
                var row="";
                for (var i = 0; i < comp.zonings.length; i++) {
                    // row += "<tr><td>"+ comp.zonings[i].zone_for_view +"</td><td>"+ comp.zonings[i].subzone_for_view +"</td><td>"+ comp.zonings[i].sq_ft_for_view +"</td></tr>";
                    row += comp.zonings[i].zone_for_view +" - "+ comp.zonings[i].subzone_for_view +" - "+ comp.zonings[i].sq_ft_for_view +" SF<br>";
                }
                // $('.prop_table_body').html(row);
                compDetail.find('.content [data-ref=prop_table_body]').html(row);
                compDetail.find('.content [data-ref=building_size]').html(comp.building_size_for_view);
                compDetail.find('.content [data-ref=business_name]').html(comp.business_name);
                compDetail.find('.content [data-ref=street_address]').html(comp.street_address);
                if(comp.street_suite!="" && comp.street_suite!=null)
                    compDetail.find('.content [data-ref=street_suite]').html(', '+comp.street_suite);
                else
                    compDetail.find('.content [data-ref=street_suite]').html('');

                compDetail.find('.content [data-ref=city]').html(comp.city);
                compDetail.find('.content [data-ref=state]').html(comp.state_for_view);
                compDetail.find('.content [data-ref=zipcode]').html(comp.zipcode);
                if (comp.type=="sale") {
                    $('.property-status').find('p').html("Sale");
                } else {
                    $('.property-status').find('p').html('Lease');
                }
                //var land_size = comp.land_size_for_view.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '';
                compDetail.find('.content [data-ref=summary]').html(comp.summary);
                compDetail.find('.content [data-ref=summary]').attr('style','text-align: justify');
                compDetail.find('.content [data-ref=concessions]').attr('style','text-align: justify');
                var land_dimension = "SF";
                if(comp.land_dimension == "ACRE")
                    land_dimension = "Acres";
                compDetail.find('.content [data-ref=land_size]').html(comp.land_size_for_view);
                if (comp.comp_type=="land_only") {
                    // compDetail.find('.content [data-ref=comp_type]').html("Land Only");
                    compDetail.find('.content [data-ref=land_type_for_view]').html(comp.land_type_for_view);
                    compDetail.find('.land_type').removeClass("hide");
                    compDetail.find('.hide-if-land-only').addClass('hide');
                } else {
                    // compDetail.find('.content [data-ref=comp_type]').html('Building with land');
                    compDetail.find('.content [data-ref=land_type_for_view]').html('');
                    compDetail.find('.land_type').addClass("hide");
                    compDetail.find('.hide-if-land-only').removeClass('hide');
                }
                compDetail.find('.content [data-ref=topography]').html(comp.topography_type);
                compDetail.find('.content [data-ref=lot_Shape]').html(comp.lot_shape_type);
                compDetail.find('.content [data-ref=frontage]').html(comp.frontage_for_view);
                compDetail.find('.content [data-ref=condition]').html(comp.condition_for_view);
                compDetail.find('.content [data-ref=sale_price]').html(comp.sale_price_for_view);
                compDetail.find('.content [data-ref=date_sold]').html(comp.date_sold_for_view);
                compDetail.find('.content [data-ref=net_operating_income]').html(comp.net_operating_income_for_view);
                compDetail.find('.content [data-ref=cap_rate]').html(comp.cap_rate_for_view);
                compDetail.find('.content [data-ref=zoning_type]').html(comp.zoning_type);
                compDetail.find('.content [data-ref=concessions]').html(comp.concessions);
                compDetail.find('.content [data-ref=utilities]').html(comp.utilities_for_view);
                compDetail.find('.content [data-ref=zoning_type]').html(comp.zoning_type);
                compDetail.find('.content [data-ref=year_built]').html(comp.year_built);
                compDetail.find('.content [data-ref=year_remodeled]').html(comp.year_remodeled);
                compDetail.find('.content [data-ref=total_operating_expense]').html(comp.total_operating_expense_for_view);
                compDetail.find('.content [data-ref=operating_expense_psf]').html(comp.operating_expense_psf_for_view);
                compDetail.find('.content [data-ref=list_price]').html(comp.list_price_for_view);
                compDetail.find('.content [data-ref=date_list]').html(comp.date_list_for_view);
                compDetail.find('.content [data-ref=days_on_market]').html(comp.days_on_market);
                compDetail.find('.content [data-ref=total_concessions]').html(comp.total_concessions_for_view);
                compDetail.find('.content [data-ref=space]').html(comp.space_for_view);
                compDetail.find('.content [data-ref=lease_type]').html(comp.lease_type_for_view);
                compDetail.find('.content [data-ref=lease_rate]').html(comp.lease_rate_for_view);
                compDetail.find('.content [data-ref=lease_rate_unit]').html(comp.lease_rate_unit_for_view);
                compDetail.find('.content [data-ref=cam]').html(comp.cam_for_view);
                compDetail.find('.content [data-ref=term]').html(comp.term);
                compDetail.find('.content [data-ref=date_execution]').html(comp.date_execution_for_view);
                compDetail.find('.content [data-ref=date_commencement]').html(comp.date_commencement_for_view);
                compDetail.find('.content [data-ref=date_expiration]').html(comp.date_expiration_for_view);
                compDetail.find('.content [data-ref=lease_status]').html(comp.lease_status_for_view);
                compDetail.find('.content [data-ref=TI_allowance]').html(comp.TI_allowance_for_view);
                compDetail.find('.content [data-ref=TI_allowance_unit]').html(comp.TI_allowance_unit_for_view);
                compDetail.find('.content [data-ref=asking_rent]').html(comp.asking_rent_for_view);
                compDetail.find('.content [data-ref=asking_rent_unit]').html(comp.asking_rent_unit_for_view);
                compDetail.find('.content [data-ref=escalators]').html(comp.escalators_for_view);
                compDetail.find('.content [data-ref=free_rent]').html(comp.free_rent);
                compDetail.find('.content [data-ref=offeror_type]').html(comp.offeror_type_for_view);
                compDetail.find('.content [data-ref=acquirer_type]').html(comp.acquirer_type_for_view);
                compDetail.find('.content [data-ref=offeror_name]').html(comp.offeror_name);
                compDetail.find('.content [data-ref=acquirer_name]').html(comp.acquirer_name);
                // $('#link-to-edit-form').attr('onclick', 'CompsController.openForm("'+ comp.id +'")');
                $('#link-to-edit-form').attr('href', $("body").data("base-url")+'/comps/overview/'+ comp.id);
                
                /*Images*/
                if (comp.property_image_url !== null) {
                    compDetail.find('.content [data-ref=image_url]').css('background-image', 'url("' + Utils.imageUrl(comp.property_image_url) + '")');
                } else {
                    compDetail.find('.content [data-ref=image_url]').css('background-image', 'url('+$("body").data("base-url")+'assets/img/no-photo-available.png');
                }
                var map_image = getCompImage(comp.map_pin_lat, comp.map_pin_lng, comp.map_pin_zoom);

                if (map_image && map_image.length > 0) {
                    compDetail.find('.content [data-ref=map_image_url]').css('background-image', 'url("' + map_image + '")');
                } else {
                    compDetail.find('.content [data-ref=map_image_url]').css('background-image', 'url('+$("body").data("base-url")+'assets/img/no-photo-available.png');
                }
            } catch (err) {
                console.log('It is not possible to load the property at the moment.');
                console.log(err);
            }
        };

        var getCompImage = function (latitude,longitude,map_zoom) {
            var imageDim = {height: 640, width: 640};
            var size = imageDim.width + "x" + imageDim.height;
            var zoom = map_zoom;
            var type = 'hybrid';
            var icon = document.getElementById('listings-map').getAttribute('data-icon');
            var center = latitude + "," + longitude;
            center = center.replace(/ /g, "+");
            var url = "https://maps.googleapis.com/maps/api/staticmap?size=" + size + "&zoom=" + zoom + "&center=" + center + "&maptype=" + type + "&markers=icon:" + icon + "|" + center + "&key=" + MapController.getKey();
            return url;
        };

        var initCarousel = function () {
            $('.carousel.carousel-slider').carousel({fullWidth: true});
            // move next carousel
            $('.moveNextCarousel').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                $('.carousel.carousel-slider').carousel('next');
            });
            // move prev carousel
            $('.movePrevCarousel').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                $('.carousel.carousel-slider').carousel('prev');
            });
            $('.materialboxed').materialbox();
        };

        // var openForm = function (id, addToEvaluation) {
        //     clearForm();
        //     $('.back-comps').click();
        //     if (id) {
        //         $('#save-comp').text('Update');
        //         $('#action').text('Edit');
        //         $('#delete-comp').show();
        //         fillInputs(id);
        //     } else {
        //         resetForm();
        //         $("#sale").prop("checked", true);
        //         $("#private_compNo").prop("checked", true);
        //         toggleType($(".select_type:checked"));
        //         $('.land_type_field').removeClass('required');
        //         $('.land_type_field').children('input').prop('required',false);
        //         $('.land_type_field').children('div.error').remove();
        //         $('#save-comp').text('Create');
        //         $('#action').text('Create');
        //         $('#delete-comp').hide();
        //         if (addToEvaluation) {
        //             $("#addToEvaluation").val("yes");
        //         }
        //         if (location.pathname.indexOf('/cost') !== -1 || (location.pathname.indexOf('/sales') !== -1 && $("#selected_comp_type").val()=="land_only")) {
        //             $("#land_only").prop("checked", true);
        //             $('.land_type_field').removeClass('s3');
        //             $('.land_type_field').removeClass('s6');
        //             $('.land_type_field').addClass('s4');
        //             $('.select_land_type').removeClass('s6');
        //             $('.select_land_type').addClass('s4');
        //             $('.select_land_type').removeClass('hide');
        //             $('.zoning_block').hide();
        //             $('.hide-if-land-only').addClass('hide');
        //         }else{
        //             $("#building_with_land").prop("checked", true);
        //         }
        //     }
        //     initEvents();
        //     updatePropertyTriggers();
        // };

        var initEvents = function () {
            $(".select_type").change(function () {
                toggleType($(this));
                setPriceSquareFoot();
            });
        };

        $(".select_lease_sale").change(function () {
            toggleTable($(this));
            $('#check_advance_filter').val(0);
            $('#clear_filter').addClass('hide');
            refresh_filters();
            update_filter_label('Apply Advance Filter','filter_alt');
            setModalFields();
        });

        var toggleTable = function (el) {
            if (el.val() === 'lease_comps') {
                $(".lease_table").show();
                $(".comp_table").hide();
            } else if (el.val() === 'sale_comps') {
                $(".comp_table").show();
                $(".lease_table").hide();
            }
        };

        var toggleType = function (el,update=0) {
            checkRequiedFields();
            if (el.val() === 'sale') {
                $("[data-ref=lease]").addClass('hide');
                $("[data-ref=sale]").removeClass('hide');
                $("[name=lease_type]").prop('required',false);
                $(".transaction_details_div").after($(".lease_type_div"));
                $(".date_div").removeClass('s6');
                $(".date_div").addClass('s4');
                $("#offeror_type option:first-child").html('-- Select Seller Type --');
                $("#offeror_type").material_select();
                $("#acquirer_type option:first-child").html('-- Select Buyer Type --');
                $("#acquirer_type").material_select();
                $(".condition_div").appendTo($(".condition_div_row"));
                $('#conditions option[value=""]').html("-- Select Property Condition --");
                $('#transaction').removeClass('hide');
                $('#transaction_menu').removeClass('hide');
                $('#space_menu').addClass('hide');
                // $("#utilities_row").after($(".zoning_div"));
                // $(".zoning_div").after($(".notes_row"));
                // $(".notes_row").after($("#hr_break"));
            } else if (el.val() === 'lease') {
                $('#transaction').addClass('hide');
                $('#transaction_menu').addClass('hide');
                $('#space_menu').removeClass('hide');
                if(update!=1)
                {
                    $("[name=price_square_foot]").val('');
                }
                $(".date_div").addClass('s6');
                $(".date_div").removeClass('s4');
                $(".space_div").after($(".condition_div"));
                $("[data-ref=lease]").removeClass('hide');
                $("[data-ref=sale]").addClass('hide');
                $("[name=lease_type]").prop('required',true);
                // $(".zoning_div").after($(".lease_type_div"));
                $(".space_div_row").after($(".lease_type_div"));
                $("#offeror_type option:first-child").html('-- Select Landlord Type --');
                $("#offeror_type").material_select();
                $("#acquirer_type option:first-child").html('-- Select Tenant Type --');
                $("#acquirer_type").material_select();
                $('#conditions option[value=""]').html("-- Select Space Condition --");
                $(".cam_row").after($(".notes_row"));
            }
            $('#conditions').material_select();
            setPriceSquareFoot();
            if ($(".check_fields").length) {
                if((el.val() !== 'sale' || $(".select_comp_type:checked").val()=="land_only") && $(".check_fields").hasClass('hide-if-land-only') && $(".check_fields").attr('data-ref')=="sale") {
                    $(".check_fields").addClass('hide');
                }else{
                    $(".check_fields").removeClass('hide');
                }
            }
        };

        var clearForm = function () {
            var form = $('#comps-form');
            form[0].reset();
            form.find('.select-wrapper').removeClass('valid');
            form.find('.input').removeClass('valid');

            $("#addToEvaluation").val("");
            $('#image').cropper('destroy');
        };

        var resetForm = function () {
            $('.side-nav').scrollTop(0);
            Utils.unsetIndexes('zonings');

            var form = $('#comps-form');
            var output = $('.comps-image-container');

            form.find('input:text, input[type="number"], input:password, input:file, textarea').val('');
            form.find('input:radio, input:checkbox').removeAttr('checked').removeAttr('selected');
            
            $("#administrative_area_level_1-error").remove();
            $('#administrative_area_level_1').removeClass('error');
            $("#conditions-error").remove();
            $('#conditions').removeClass('error');
            $("#administrative_area_level_1").val('');
            $("#years").val('');
            $("#conditions").val('');
            $("input[name='zonings[index][id]']").val('');
            $("select[name='zonings[index][zone]']").removeClass('error');
            $("select[name='zonings[index][sub_zone]']").removeClass('error');
            $("select[name='zonings[index][zone]']")[0].selectedIndex = 0;
            $("select[name='zonings[index][sub_zone]']").find('option').remove().end().append($('<option>', {
                value: '',
                text: '-- Select a Subtype --'
            }));
            $("input[name='zonings[index][sq_ft]']").val('');
            $("select[name='zonings[index][zone]']").material_select();
            $("select[name='zonings[index][sub_zone]']").material_select();

            $('#administrative_area_level_1').material_select();
            $('#years').material_select();
            $('#conditions').material_select();
            $(".condition-type-option").addClass('enable-type-own');
            $('#utilities_select option:first-child').attr("selected", "selected");
            $("#utilities_select").material_select();
            $(".utilities_select-type-option").addClass('enable-type-own');
            $('.utilities_type_field').removeClass('s12');
            $('.utilities_type_field').addClass('s6');
            $("select[name='frontage'] option:first-child").attr("selected", "selected");
            $("select[name='frontage']").material_select();
            $(".frontage-type-option").addClass('enable-type-own');
            $("select[name='land_dimension'] option:first-child").attr("selected", "selected");
            $("select[name='land_dimension']").material_select();
            $("select[name='type'] option:first-child").attr("selected", "selected");
            $("select[name='type']").material_select();
            $("select[name='lease_rate_unit'] option:first-child").attr("selected", "selected");
            $("select[name='lease_rate_unit']").material_select();
            $("select[name='sale_status'] option:first-child").attr("selected", "selected");
            $("select[name='sale_status']").material_select();
            
            $("input[name='land_type']").val('');
            $("select[name='land_type']").material_select();
            $("label[for='condition']").removeClass("active");
            $("label[for='states']").removeClass("active");
            $("select[name='lease_type']").val('');
            $("select[name='lease_type']").material_select();
            $("#lease_type-error").remove();
            $("select[name='lease_type']").removeClass('error');
            $("select[name='topography'] option:first-child").attr("selected", "selected");
            $("select[name='topography']").material_select();
            $(".topography-type-option").addClass('enable-type-own');
            $("select[name='lot_shape'] option:first-child").attr("selected", "selected");
            $("select[name='lot_shape']").material_select();
            $(".lot_shape-type-option").addClass('enable-type-own');
            $("select[name='lease_status'] option:first-child").attr("selected", "selected");
            $("select[name='lease_status']").material_select();
            $("select[name='TI_allowance_unit'] option:first-child").attr("selected", "selected");
            $("select[name='TI_allowance_unit']").material_select();
            $("select[name='asking_rent_unit'] option:first-child").attr("selected", "selected");
            $("select[name='asking_rent_unit']").material_select();
            $('[name="summary"]').keyup();
            $('[name="concessions"]').keyup();
            
            $('.property-type-row').each(function (i, val) {
                if (i !== 0) {
                    $(val).remove();
                }
            });
            $('.property-type-row').last().find('#subzone_type_custom0-error').remove();
            $('.property-type-row').last().find('.subzone_type_custom').attr('aria-describedby','subzone_type_custom0-error');
            
            $('.subzone-type-option, .land-type-option').addClass('enable-type-own');

            $('.property_width').removeClass('s3');
            $('.property_width').addClass('s4');
            $('.subzone_width').removeClass('s5');
            $('.subzone_width').addClass('s4');
            
            $('.property-type-row').find('.zonings.property_type').next('.error').remove();
            $('.property-type-row').find('.zonings.property_sub_type').next('.error').remove();
            $('.property-type-row').find('.zonings.space').next('.error').remove();
            output.css({'background': ''});
            $('.property-type-row').show();
            $('.select_land_type').addClass('hide');
            $('.land_type').prop('required',false);
            $('.land_type_field').removeClass('s4');
            $('.land_type_field').addClass('s6');
            $('[name=land_type]').val('');
            $('[name=land_type]').material_select();
            $('.zoning_block').show();
            $('#id').val("");
            MapController.CompsPin.reset();
            $("input[name='latitude']").val("");
            $("input[name='longitude']").val("");
            $("select[name='offeror_type'] option:first-child").attr("selected", "selected");
            $("select[name='offeror_type']").material_select();
            $('[name="offeror_id"]').find('option').remove().end();
            $('[name="offeror_id"]').material_select();
            $("select[name='acquirer_type'] option:first-child").attr("selected", "selected");
            $("select[name='acquirer_type']").material_select();
            $('[name="acquirer_id"]').find('option').remove().end();
            $('[name="acquirer_id"]').material_select();
            $('.hide-if-land-only').removeClass('hide');
            $("input[name='land_size']").removeClass("money-acre");
            $("input[name='land_size']").addClass("postmask-integer");
            $('.standalone-datepicker').each(function() { 
                $(this).data('daterangepicker').setStartDate(Utils.getToday());
                $(this).data('daterangepicker').setEndDate(Utils.getToday());
            });
            MapController.CompsPin.init();

            clearForm();

            iteratePropertyControls();
        };

        // var fillInputs = function (id) {
        //     $.ajax({
        //         type: "GET",
        //         url: $("body").data("base-url") + "comps/get",
        //         data: {id: id, normalize: true},
        //         success: function (responseText) {
        //             var comp = JSON.parse(responseText);
        //             if (comp.id) {
        //                var flag=false;
        //                var property;
        //                for (property in comp) {
        //                    if (comp.hasOwnProperty(property)) {
        //                         if (property.toString() === 'zonings') {
        //                             for (var j = 0; j < comp[property].length; j++) {
        //                                 if(comp[property][j].subzone_type_custom!=="")
        //                                 {
        //                                     flag=true;
        //                                 }
        //                             }
        //                             if(flag)
        //                             {
        //                                 $('.property_width').removeClass('s4');
        //                                 $('.property_width').addClass('s3');
        //                                 $('.subzone_width').removeClass('s4');
        //                                 $('.subzone_width').addClass('s3');
        //                             }else{
        //                                 $('.property_width').removeClass('s3');
        //                                 $('.property_width').addClass('s4');
        //                                 $('.subzone_width').removeClass('s3');
        //                                 $('.subzone_width').addClass('s4');
        //                             }
        //                         }
        //                     }
        //                }
        //                 for (property in comp) {
        //                     if (comp.hasOwnProperty(property)) {
        //                         if (property.toString() === 'zonings') {
        //                             $('.property-type-row').last().find('#subzone_type_custom0-error').remove();
        //                             var initialPropertyTypeDiv = $('.property-type-row').last();
        //                             var propertyTypeDiv = initialPropertyTypeDiv.clone();
        //                             for (var i = 0; i < comp[property].length; i++) {
        //                                 if (i === 0) {
        //                                     fillZoning(initialPropertyTypeDiv, comp[property][i],i);
        //                                 } else {
        //                                     propertyTypeDiv = initialPropertyTypeDiv.clone();
        //                                     initialPropertyTypeDiv.after(propertyTypeDiv);
        //                                     fillZoning(propertyTypeDiv, comp[property][i],i,flag);
        //                                 }
        //                             }
        //                             updatePropertyTriggers();
        //                             initPropertyTypeSqftEvent();
        //                         } else {
        //                             var input = $("[name=" + property + "]");
        //                             var firstChiled = $("select[name="+property+"] option:first-child");
        //                             if (input.is("input")) {
        //                                 if (property.indexOf('property_image_url') === 0) {
        //                                     if (comp[property]) {
        //                                         var url = $("body").data("cdn-url") + comp[property];
        //                                         var preloaderImg = document.createElement("img");
        //                                         preloaderImg.src = url;
        //                                         preloaderImg.addEventListener('load', loadPreLoaderImg(url));
        //                                         preloaderImg.addEventListener('error', errorPreLoaderImg);
        //                                     }
        //                                 } else if (property.indexOf('date_sold') === 0) {
        //                                     if (comp.date_sold_for_input) {
        //                                         input.val(comp.date_sold_for_input);
        //                                     }
        //                                     if (comp.date_sold_for_input) {
        //                                         input.data('daterangepicker').setStartDate(comp.date_sold_for_input);
        //                                     }
        //                                     if (comp[property]) {
        //                                         $("label[for='" + property + "']").addClass("active");
        //                                     }
        //                                 } else if (input.is(":radio")) {
        //                                     if(property == "private_comp")
        //                                     {
        //                                         if(comp[property] == "1")
        //                                         {
        //                                             $("#private_compYes").prop("checked", true);
        //                                         }else{
        //                                             $("#private_compNo").prop("checked", true);
        //                                         }
        //                                     }else{
        //                                         $("#"+comp[property]).prop('checked',true).change();
        //                                     }
        //                                 } else {
        //                                     input.val(comp[property]);
        //                                     if (comp[property]) {
        //                                         $("label[for='" + property + "']").addClass("active");
        //                                     }
        //                                 }
        //                             } else if (input.is("select")) {
        //                                 if(property=="land_type")
        //                                 {
        //                                     if(comp[property]=="Type My Own")
        //                                         {
        //                                         $('.land_type_field').removeClass('s6');
        //                                         $('.land_type_field').removeClass('s4');
        //                                         $('.land_type_field').addClass('s3');
        //                                         $('.select_land_type').removeClass('s4');
        //                                         $('.select_land_type').addClass('s6');
        //                                         $("#land_type_custom").attr('required',true);
        //                                     }else{
        //                                         $('.land_type_field').removeClass('s3');
        //                                         $('.land_type_field').removeClass('s6');
        //                                         $('.land_type_field').addClass('s4');
        //                                         $('.select_land_type').removeClass('s6');
        //                                         $('.select_land_type').addClass('s4');
        //                                         $("#land_type_custom").attr('required');
        //                                     }
        //                                 }
        //                                 if((property=="lease_rate_unit" || property=="TI_allowance_unit" || property=="asking_rent_unit") && comp[property]==null)
        //                                 {
        //                                     comp[property]=$("select[name='"+ property +"'] option:first-child").val();
        //                                 }
        //                                 if(comp[property]==null || comp[property]=="")
        //                                     firstChiled.attr("selected", "selected");
        //                                 else
        //                                     input.val(comp[property]).change();
        //                                 input.material_select();
        //                             } else if (input.is("textarea")) {
        //                                 input.val(comp[property]).change();
        //                                 input.keyup();
        //                             }
        //                         }
        //                     }
        //                 }
        //             }
        //             toggleType($("select[name='type']"),1);
        //             MapController.CompsPin.setSelectedPin();
        //         },
        //         failure: function (errMsg) {
        //             Utils.unsetIndexes('zonings');
        //         }
        //     }).done(function () {
        //         Utils.unsetIndexes('zonings');
        //         $('.standalone-datepicker').each(function() { 
        //             if($(this).val()!=""){
        //                 $(this).data('daterangepicker').setStartDate($(this).val());
        //                 $(this).data('daterangepicker').setEndDate($(this).val());
        //             }else{
        //                 $(this).data('daterangepicker').setStartDate(Utils.getToday());
        //                 $(this).data('daterangepicker').setEndDate(Utils.getToday());
        //             }
        //         });
        //         focusInPostMasks();
        //         if ($(".check_fields").length) {
        //             if(($(".select_type:checked").val() !== "sale" || $(".select_comp_type:checked").val()=="land_only") && $(".check_fields").hasClass('hide-if-land-only') && $(".check_fields").attr('data-ref')=="sale") {
        //                 $(".check_fields").addClass('hide');
        //             }else{
        //                 $(".check_fields").removeClass('hide');
        //             }
        //         }
        //         if($(".select_comp_type:checked").val()=="land_only"){
        //             $('.land_type_field').addClass('required');
        //             $('.land_type_field').children('input').prop('required',true);
        //         }
        //     });
        // };

        var loadPreLoaderImg =  function (url) {
            var output = $('.comps-image-container');

            output.css("background-image", "url('" + url + "')");
            output.css("background-size", "auto 100%");
            output.css("background-position", "center");
            output.css("background-repeat", "no-repeat");
            output.css("background-color", "#f9f9f9");

            $(".comps-image").fadeTo("fast", 0);
        };

        var errorPreLoaderImg =  function () {
            $('.comps-image-container').children().first().css('opacity', 1);
        };

        var initPropertyTypeSqftEvent = function () {

            var comps_property_type = $('select.property_type').val();
            
            if (comps_property_type === 'land') {
                $('#comps_sq_ft_field').hide();    
            }else{
                $('#comps_sq_ft_field').show();
            }

            //add active label to loaded zonings
            $("[name='zonings[index][sq_ft]']").each(function (i, el) {
                var prev = $(el).prev();
                if (prev.prop("tagName").toLowerCase() === 'label') {
                    prev.addClass('active');
                }
            });
            $("[name='zonings[index][unit]']").each(function (i, el) {
                var prev = $(el).prev();
                if (prev.prop("tagName").toLowerCase() === 'label') {
                    prev.addClass('active');
                }
            });
            $("[name='zonings[index][bed]']").each(function (i, el) {
                var prev = $(el).prev();
                if (prev.prop("tagName").toLowerCase() === 'label') {
                    prev.addClass('active');
                }
            });

            //add sq ft event to add up building size
            if ($('.zonings[data-attribute="sq_ft"]').length > 0) {
                $('.zonings[data-attribute="sq_ft"]').keyup(_.debounce(calculateBuildingSize, 500));
            }

        };

        var fillZoning = function (div, zoning,count=null) {
            if(zoning.sub_zone=="Type My Own")
            {
                div.find('.subzone-type-option').removeClass('enable-type-own');
                div.find("input[name='zonings[index][subzone_type_custom]']").attr('required',true);
            }else{
                div.find('.subzone-type-option').addClass('enable-type-own');
                div.find("input[name='zonings[index][subzone_type_custom]']").attr('required',false);
            }
            div.find("input[name='zonings[index][id]']").val(zoning.id);
            div.find("select[name='zonings[index][zone]']").val(zoning.zone);
            loadSubzoning(div, zoning);
            div.find("select[name='zonings[index][sub_zone]']").val(zoning.sub_zone);
            div.find("input[name='zonings[index][sq_ft]']").val(zoning.sq_ft);
            div.find("input[name='zonings[index][subzone_type_custom]']").val(zoning.subzone_type_custom);
            div.find("input[name='zonings[index][subzone_type_custom]']").attr('aria-describedby','subzone_type_custom'+count+'-error');
            div.find("select[name='zonings[index][zone]']").material_select();
            div.find("select[name='zonings[index][sub_zone]']").material_select();
            div.find("input[name='zonings[index][unit]']").val(zoning.unit);
            div.find("input[name='zonings[index][bed]']").val(zoning.bed);

            div.find('.subzone-type-option').addClass('subzone-type-option'+count);
            var remove=parseInt(count)-1;
            if(count>0)
                div.find('.subzone-type-option').removeClass('subzone-type-option0');

            div.find('.subzone-type-option').removeClass('subzone-type-option'+remove);
            div.find('select.property_sub_type').attr('onchange','change_custom_field(this,`subzone-type-option'+count+'`,`subzone_type_custom'+count+'`,`zone`)');
            div.find('.subzone_type_custom').attr('id','subzone_type_custom'+count);
        };

        var loadSubzoning = function (div, zoning) {
            var subInput = div.find('select.property_sub_type');
            var subType = subInput.attr('data-subtype');

            var value = zoning.zone;
            var sub = $.parseJSON(subType);
            var options = '';
            if (typeof sub[value] !== 'undefined') {
                var children = sub[value].children;
                if (typeof children !== 'undefined') {
                    for (var child in children) {
                        if (children.hasOwnProperty(child)) {
                            options += "<option value='" + child + "'>" + children[child] + "</option>";
                            $(subInput).attr('disabled', false);
                        }
                    }
                } else {
                    options = "<option value='0'>No Subtypes</option>";
                    $(subInput).attr('disabled', true);
                }
            }

            if (options.length === 0) {
                options = "<option value=''>-- Select a Subtype --</option>";
            }

            $(subInput).html(options).material_select();
        };
        
        $('#open_upload_comps_modal').click(function (e) {                     
            $("#upload_comps_modal").modal('open');
        });

        var initialize = function () {
            // if($("#delete-comp").length)
            //     document.getElementById("delete-comp").addEventListener("click", deleteComp);
            document.getElementById("save-comp").addEventListener("click", saveComp);
            TableController.Comps.init();
            TableController.Lease.init();
            if($("#verify_excel").length)
                document.getElementById("verify_excel").addEventListener("click", saveCompExcel);
            if($("#open_advance_filter_modal").length)
                document.getElementById("open_advance_filter_modal").addEventListener("click", openAdvanceFilter);
        };

        $('.upload_comps_close').click(function (e) {     
            $("input[name='file']").val('');
            $("input[type='file']").val('');
            $("#file-error").remove();
        });
        let search = location.search.indexOf('evaluation');
        if (location.pathname.indexOf('/comps') !== -1 || location.pathname.indexOf('/master-properties') !== -1){
            if(search == -1){
                initialize();
                // loadSideNav();
            }
            if(location.pathname.indexOf('/comps/overview') !== -1){
                initEvents();
                updatePropertyTriggers();
                toggleType($(".select_type:checked"),1);
                if($('#id').val() == '' || $(".select_comp_type:checked").val()!=="land_only"){
                    $('.land_type_field').removeClass('required');
                    $('.land_type_field').children('input').prop('required',false);
                    $('.land_type_field').children('div.error').remove();
                }
                initImageCropper();
            }
            // else if(location.pathname.indexOf('/comps') !== -1){
                // openForm();
            // }
        }

        if (window.CompsController === undefined) {
            window.CompsController = {};
        }

        window.CompsController = {
            // "openForm": openForm,
            // "closeForm": closeForm,
            // "resetForm": resetForm,
            "saveComp": saveComp,
            // "loadSideNav": loadSideNav,
            "showDetails": showDetails,
            "closeDetails":closeDetails
        };
    })();
});

function change_type(obj) {
    var value = $(obj).val();
    if (value == "land_only") {
        $('.comp_type').hide();
    } else {
        $('.comp_type').show();
    }
}